import { requestMfaProcedureSuccess } from 'common/components/ModalMFA/actions';
import type { AppDispatch } from 'modules/app/redux/store';
import type { AuthenticationMethod } from 'modules/authentication-factor/models/authenticationFactors';
import { postV2ApiCardsPaymentPasswordReset } from 'src/client/spendesk-api';
import { type PostV2ApiCardsPaymentPasswordResetResponseOK } from 'src/client/spendesk-api-types';

type PostResetPaymentPasswordRequestInput = {
  authenticationMethod: AuthenticationMethod;
};

export const postResetPaymentPassword = async (
  { authenticationMethod }: PostResetPaymentPasswordRequestInput,
  // Dispatching is only used for the SMS fallback flow.
  dispatch?: AppDispatch,
): Promise<PostV2ApiCardsPaymentPasswordResetResponseOK> => {
  const response = await postV2ApiCardsPaymentPasswordReset({
    body: {
      authenticationMethod,
    },
  });
  if (response.statusCode === 200) {
    const { procedureId, factorId } = response.body;

    if (authenticationMethod === 'mfa' && factorId) {
      // Dispatching so that it would be used by ModalMFAToken
      dispatch(
        requestMfaProcedureSuccess({
          id: procedureId,
          factorId,
        }),
      );
    }

    return {
      procedureId,
      factorId,
    };
  }
  throw new Error('Payment password reset failed');
};
